<template>
   <BaseContainer>
      <BaseContentContainer>
  <h1 class="display-6 text-center mb-4">Computational Thinking</h1>

  <div class="fs-5 mb-4 text-center">
    Computational thinking is a structured method to tackle problems using techniques that guide you in creating efficient algorithms. These models provide a toolkit of "thinking steps" and guiding questions to solve complex challenges, especially in programming.
  </div>

  <div class="card border-success mb-4">
    <div class="card-header bg-success text-white fw-semibold">
      Core Concepts of Computational Thinking
    </div>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>Abstraction</strong> — Focus on essential details by ignoring irrelevant information to model the problem effectively.</li>
      <li class="list-group-item"><strong>Decomposition</strong> — Break down a large problem into manageable components or sub-problems.</li>
      <li class="list-group-item"><strong>Pattern Recognition</strong> — Detect similarities, trends, and repeated structures across problems.</li>
      <li class="list-group-item"><strong>Algorithm Design</strong> — Develop a sequence of repeatable steps that lead to a solution.</li>
    </ul>
  </div>

  <div class="card border-0 shadow-sm mb-5 p-4">
    <h5 class="text-success">Applying Computational Thinking in Programming</h5>
    <p class="mb-3">
      When solving programming problems, these four skills help break down and frame your approach. Here’s how each step fits within a coding context:
    </p>
    <ul class="list-group list-group-flush">
      <li class="list-group-item"><strong>1. Decomposition:</strong> Can I divide the task into smaller sub-problems?</li>
      <li class="list-group-item"><strong>2. Pattern Recognition:</strong> Are there recurring solutions or inputs I can generalize?</li>
      <li class="list-group-item"><strong>3. Abstraction:</strong> Can I filter out the unnecessary to define a clear model?</li>
      <li class="list-group-item"><strong>4. Algorithm Design:</strong> Can I define clear, step-by-step instructions to solve each part?</li>
    </ul>
  </div>

  <div class="card bg-light p-4 shadow-sm">
    <h5 class="text-success">Example Problem-Solving Steps</h5>
    <ol class="mb-0">
      <li>Start with a small version of the problem that you can solve manually.</li>
      <li>Apply the four thinking skills to identify an effective approach.</li>
      <li>Test your solution on larger, real-world examples.</li>
      <li>Refine and adapt until the solution is complete and reliable.</li>
    </ol>
  </div>
 </BaseContentContainer>
</BaseContainer>

</template>

<script>
import BaseContainer  from '@/components/BaseContainer.vue';
import BaseContentContainer  from '@/components/BaseContentContainer.vue';
export default {
  name: 'CoursesView',
    components: {
      BaseContainer,BaseContentContainer,
  },
}

</script>